// removed by extract-text-webpack-plugin
module.exports = {"tablaFacturas":"TablaFacturas__tablaFacturas___2qp9H","thCorrelativo":"TablaFacturas__thCorrelativo___fE2V-","thDocumento":"TablaFacturas__thDocumento___zO4VG","thFecha":"TablaFacturas__thFecha___2wr0Y","thMonto":"TablaFacturas__thMonto___2gilD","thNumero":"TablaFacturas__thNumero___1fK7Q","thDescarga":"TablaFacturas__thDescarga___oXymp","tdDocumento":"TablaFacturas__tdDocumento___2fgXc","tdNumero":"TablaFacturas__tdNumero___1nzAI","tdMonto":"TablaFacturas__tdMonto___iu7bz","tdFecha":"TablaFacturas__tdFecha___1_fB5","tdDescarga":"TablaFacturas__tdDescarga___1KkJE"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/facturacion/lista-facturas/cliente-fcv/TablaFacturas.css
// module id = 1135
// module chunks = 0